export default "__VITE_ASSET__10700287__"